import React, { useEffect, useState } from 'react'
import moment from 'moment'
import Message from '../message/Message'
import DottedLoader from '../loader/dottedLoader/DottedLoader'
import Header from '../Header/Header'
import { useCookies } from 'react-cookie'
import { postReq } from '../../auth/jwtService'
import Spinner from '../loader/spinner/Spinner'

const ChatSection = ({ selectedAstra = '', milestone = '', date = '', section = '' }) => {

    const [cookies] = useCookies(['user'])
    const user_id = cookies.user_id;
    const token = cookies.token;
    const [conversation, setConversation] = useState([])
    const [ansLoading, setAnsLoading] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const firstQuestions = {
        dist_bkb_astra: [
            "Whats my service astra status?",
            "Whats my sale astra status?",
            "Whats my retailer astra status?"
        ],
        dist_bkb_milestones: [
            "How to increase BKB points using cash rotation bonus feature?",
            "How to increase BKB points using cash rotation bonus feature?"
            // "Help me achieve 10 lakh milestone",
            // "Help me achieve 25 lakh milestone"
        ]
    }

    const getAnswer = (question) => {
        if (ansLoading) return
        setAnsLoading(true)
        const newMessage = {
            id: Date.now(),
            question,
            answer: <div style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
                gap: "10px",
                fontSize: "12px",
                marginBottom: "50vh"
            }}>
                Typing<DottedLoader />
            </div>,
            graph: null,
        }

        setConversation((prev) => [...prev, newMessage])

        const form_data = new FormData()
        form_data.append('user_id', user_id)
        form_data.append('token', token)
        // form_data.append('dist_user_id', 'Jai mata di Enterprise [37040514]')
        form_data.append('sdate', date)
        form_data.append('section', section)
        form_data.append("question", question)

        postReq("/api/jt_response", form_data)
            .then((res) => {
                console.log(res, 'res')
                const botResponse =
                    res?.data?.description?.bot_resp ||
                    "Sorry, I couldn't process your question."
                const graphResponse = res.data.description.graph_resp || null
                const nextQuestions = res?.data?.description?.next_questions || []
                const switchOptions = res?.data?.description?.switch_options || []
                const timestamp = res?.data?.description?.timestamp || ''

                setConversation((prev) => {
                    return prev.map((msg) =>
                        msg.id === newMessage.id
                            ? { ...msg, answer: botResponse, graph: graphResponse, next_questions: nextQuestions, switch_options: switchOptions, timestamp: timestamp, isResponse: true }
                            : msg
                    )
                })

                setAnsLoading(false)
            })
            .catch(() => {
                setConversation((prev) => {
                    return prev.map((msg) =>
                        msg.id === newMessage.id
                            ? {
                                ...msg,
                                answer:
                                    "Sorry, something went wrong while processing your request.",
                            }
                            : msg
                    )
                })
                setAnsLoading(false)
            })
    }

    const getHistory = () => {
        setIsLoading(true)
        const form_data = new FormData()
        form_data.append('user_id', user_id)
        form_data.append('token', token)
        // form_data.append('dist_user_id', 'Jai mata di Enterprise [37040514]')
        form_data.append('sdate', date)
        form_data.append('section', section)

        postReq("/api/jt_history", form_data)
            .then((res) => {
                const data = res?.data?.description;
                setConversation(data[date] || []);

                let question = ''
                if (section === 'dist_bkb_astra') {
                    question =
                        selectedAstra === 'Service'
                            ? firstQuestions.dist_bkb_astra[0]
                            : selectedAstra === 'Sale'
                                ? firstQuestions.dist_bkb_astra[1]
                                : firstQuestions.dist_bkb_astra[2]
                } else if (section === 'dist_bkb_milestones') {
                    question =
                        milestone === '10L'
                            ? firstQuestions.dist_bkb_milestones[0]
                            : firstQuestions.dist_bkb_milestones[1]
                }

                if (question) {
                    getAnswer(question)
                } else {
                    console.error("No valid question found.")
                }
                setIsLoading(false)
            })
            .catch((err) => {
                console.error("Error fetching history:", err)
                setIsLoading(false)
            })
    }

    const handleNextQuestionClick = (question) => {
        getAnswer(question)
    }

    const handleAstraChange = (astra) => {
        let question = ''
        if (section === 'dist_bkb_astra') {
            question =
                astra === 'Service'
                    ? firstQuestions.dist_bkb_astra[0]
                    : astra === 'Sale'
                        ? firstQuestions.dist_bkb_astra[1]
                        : firstQuestions.dist_bkb_astra[2]
        } else if (section === 'dist_bkb_milestones') {
            question =
                milestone === '10L'
                    ? firstQuestions.dist_bkb_milestones[0]
                    : firstQuestions.dist_bkb_milestones[1]
        }

        if (question) {
            getAnswer(question)
        } else {
            console.error("No valid question found.")
        }
    }

    const addNewMessage = (newMessage) => {
        setConversation((prev) => [...prev, newMessage]);
    }

    useEffect(() => {
        getHistory()
    }, [])


    return (
        <>
            <Header>
                <div
                    style={{
                        marginTop: "5px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    <p
                        style={{
                            fontSize: "12px",
                            color: "#95989a",
                            textAlign: "left",
                        }}
                    >
                        {moment(date).format('DD MMM YYYY')}
                    </p>
                </div>
                {
                    !isLoading ? (

                        conversation.map((item) => {
                            return (
                                <Message key={item.id} message={item} handleNextQuestionClick={handleNextQuestionClick} handleAstraChange={handleAstraChange} onNewMessage={addNewMessage} />
                            )
                        })
                    ) : (
                        <div
                            style={{
                                height: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                        >
                            <Spinner />
                        </div>
                    )
                }
            </Header>
        </>
    )
}

export default ChatSection